export default __webpack_public_path__ + "static/media/007-stamp.5a899773.png";